// src/config/app-route.jsx
import React from 'react';
import App from './../app.jsx';
import { Navigate } from 'react-router-dom';

import Dashboard from './../pages/dashboard/dashboard.js';
import QuizCreate from '../pages/QuizCreate/QuizCreate.js';
import ChannelCreate from '../pages/ChannelCreate/ChannelCreate.js';
import ChannelList from '../pages/ChannelList/ChannelList.js';
import QuizList from '../pages/QuizList/QuizList.js';
import { RouteWrapper } from '../components/routewrapper/routewrapper.js';
import Login from '../pages/Login/Login.js';
import XVidCreate from '../pages/XVidCreate/XVidCreate.js';
import XVidList from '../pages/XvidList/XvidList.js';
import SongReelCreate from '../pages/SongReelCreate/SongReelCreate.js';
import SongReelList from '../pages/SongReelList/SongReelList.js';

const AppRoute = [
  {
    path: '*', 
    element: <App />,
    children: [
      { path: '', element: <Navigate to='/dashboard' /> },
      { path: 'dashboard', element: <RouteWrapper component={Dashboard} /> },
      { path: 'create-quiz/:id?', element: <RouteWrapper component={QuizCreate} /> },
      { path: 'list-quizes', element: <RouteWrapper component={QuizList} /> },
      { path: 'create-channel', element: <RouteWrapper component={ChannelCreate} /> },
      { path: 'list-channels', element: <RouteWrapper component={ChannelList} /> },
      { path: 'create-xvid/:id?', element: <RouteWrapper component={XVidCreate} /> },
      { path: 'list-xvid', element: <RouteWrapper component={XVidList} /> },
      { path: 'create-song-reel/:id?', element: <RouteWrapper component={SongReelCreate} /> },
      { path: 'list-song-reels', element: <RouteWrapper component={SongReelList} /> },
      { path: 'login', element: <RouteWrapper component={Login} /> }
    ]
  }
];

export default AppRoute;
